/** Use parent frame (Connected Center dashboard) for authenticated API calls. */
import {nexusDebugLog} from './nexus-debug-log';
import {encodeProjectForBridge} from './nexus-project-bytes';

export const shouldUseParentBridge = () => (
    typeof window !== 'undefined' && window.parent !== window
);

export const ccParentRequest = (type, payload, timeoutMs = 120000) => new Promise((resolve, reject) => {
    const requestId = `cc_${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
    const resultType = `${type}-result`;

    nexusDebugLog('NexusBlocks', `Bridge request → parent: ${type}`, {
        requestId,
        endpoint: payload.endpoint || null,
        gameId: payload.gameId || null,
        title: payload.title || null
    });

    const timer = setTimeout(() => {
        window.removeEventListener('message', onMessage);
        nexusDebugLog('NexusBlocks', `Bridge timeout: ${type}`, {requestId}, 'error');
        reject(new Error('Request timed out'));
    }, timeoutMs);

    const onMessage = event => {
        const data = event.data;
        if (!data || data.type !== resultType || data.requestId !== requestId) {
            return;
        }
        clearTimeout(timer);
        window.removeEventListener('message', onMessage);
        if (data.error) {
            nexusDebugLog('NexusBlocks', `Bridge error: ${type}`, {requestId, error: data.error}, 'error');
            reject(new Error(data.error));
            return;
        }
        nexusDebugLog('NexusBlocks', `Bridge success: ${type}`, {requestId});
        resolve(data);
    };

    window.addEventListener('message', onMessage);
    window.parent.postMessage(Object.assign({type, requestId}, payload), '*');
});

export const ccParentUpload = ({project, filename, title, gameId, visibility}) =>
    encodeProjectForBridge(project).then(encoded => {
        nexusDebugLog('NexusBlocks', 'Preparing publish upload via parent bridge', {
            filename,
            title,
            gameId: gameId || null,
            visibility,
            bytes: encoded.byteLength
        });
        return ccParentRequest('cc-publish-game', {
            projectBase64: encoded.projectBase64,
            byteLength: encoded.byteLength,
            filename,
            title,
            gameId: gameId || null,
            visibility: visibility || 'public'
        });
    }).then(result => result.data);

export const ccParentApiFetch = (endpoint, {method = 'GET', jsonBody = null} = {}) =>
    ccParentRequest('cc-api-fetch', {
        endpoint,
        method,
        jsonBody
    }).then(result => {
        if (result.error) {
            throw new Error(result.error);
        }
        return result.data;
    });

export const ccParentApiPostForm = (endpoint, fields) =>
    ccParentRequest('cc-api-form', {
        endpoint,
        fields
    }).then(result => {
        if (result.error) {
            throw new Error(result.error);
        }
        return result.data;
    });
